<div class="dialog">
  <h3>Dodaj strelca</h3>
  <form (ngSubmit)="onSave()">
    <label>
      Šifra strelca:
      <input
        type="number"
        [(ngModel)]="strelci.member_id"
        name="member_id"
        required
        [disabled]="isEditMode"
      >
    </label>
    <label>
      Ime in priimek:
      <input
        type="text"
        [(ngModel)]="strelci.full_name"
        name="full_name"
        required
        placeholder="Ime in priimek"
        style="width: 100%;"
      >
    </label>
    <label>
      Spol:
      <select [(ngModel)]="strelci.spol" name="spol" required>
        <option value="">-- izberi --</option>
        <option value="M">M</option>
        <option value="Ž">Ž</option>
      </select>
    </label>
    <label>
      Klub:
      <select [(ngModel)]="strelci.klub" name="klub" required>
        <option value="">-- izberi klub --</option>
        <option *ngFor="let club of clubs" [value]="club.club_id">
          {{ club.club_id }} - {{ club.name }}
        </option>
      </select>
    </label>
    <div class="dialog-actions">
      <button type="submit">Shrani</button>
      <button type="button" (click)="onCancel()">Prekliči</button>
    </div>
  </form>
</div>